import { useState } from 'react';
import { Button, Field, Input, Notice } from '../components/ui';
import { useAuth } from './AuthContext';

export function LoginPage() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <img src="/logo.png" alt="ISawBazaar" />
          <div className="login__rule" />
          <div className="login__title">ISawBazaar Admin</div>
          <div className="login__sub">Operations console</div>
        </div>

        <div className="stack">
          {error && <Notice tone="danger">{error}</Notice>}

          <Field label="Email">
            <Input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@isawbazaar.local"
              required
              autoFocus
            />
          </Field>

          <Field label="Password">
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </Field>

          <Button type="submit" variant="primary" loading={busy}>
            Sign in
          </Button>

          <div style={{ fontSize: 12, color: 'var(--ink-faint)', textAlign: 'center', lineHeight: 1.6 }}>
            Admin accounts sign in with a password.
            <br />
            Everyone else uses mobile + OTP in the app.
          </div>
        </div>
      </form>
    </div>
  );
}
